import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateReportingStatusQueries } from "./invalidateCleDocumentQueries";

export const useInvalidateReportingStatus = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    invalidateReportingStatusQueries(queryClient);
  }, [queryClient]);
};
